import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import './styles.css';
import './styles-ide.css';
import './styles-board.css';
import './styles-chat.css';
import './styles-git.css';
import './styles-editor.css';
import './styles-pixel.css';
import './styles-shell.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root container missing from index.html');

container.innerHTML = '';

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);